<template>
  <div class="dateTypeChangeCom">
    <el-select
      v-if="selectType == 'select'"
      v-model="timeType"
      placeholder="请选择"
      size="mini"
      @change="getDataValue"
    >
      <el-option
        v-for="v in dateList"
        :key="v.value"
        :label="v.label"
        :value="v.value"
      >
      </el-option>
    </el-select>
    <el-radio-group
      v-if="selectType == 'radio'"
      v-model="timeType"
      size="mini"
      style="margin-right: 10px"
      @change="getDataValue"
    >
      <el-radio-button v-for="v in dateList" :key="v.value" :label="v.value">
        {{ v.label }}
      </el-radio-button>
    </el-radio-group>
    <template v-if="timeType !== 'UNLIMITED'">
      <el-date-picker
        size="mini"
        :picker-options="pickerOptions"
        v-model="timeValue"
        :clearable="false"
        :type="
          timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
        "
        :key="
          timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
        "
        :value-format="
          timeType == 'YEAR'
            ? 'yyyy'
            : timeType == 'MONTH'
            ? 'yyyy-MM'
            : 'yyyy-MM-dd'
        "
      >
      </el-date-picker>
    </template>
    <el-button size="mini" @click="submit" type="primary">查询</el-button>
    <el-button
      type="primary"
      size="mini"
      plain
      style="margin-right: 20px"
      v-if="showExport"
      @click="$parent.exportExcel()"
      ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
    >
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    dateList: {
      type: Array,
      default: () => [
        { label: "日", value: "DAY" },
        { label: "月", value: "MONTH" },
        { label: "年", value: "YEAR" },
        { label: "全部", value: "UNLIMITED" },
      ],
    },
    showExport: {
      type: Boolean,
      default: false,
    },
    selectType: {
      type: String,
      default: "select",
    },
  },
  data() {
    return {
      timeType: "",
      timeValue: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    dateList: {
      handler: function (val, oldVal) {
        this.handleDefaultTime();
      },
      deep: true,
    },
  },
  methods: {
    handleDefaultTime() {
      this.timeType = this.dateList[0].value;
      this.getDataValue();
    },
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
      } else if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
      } else if (this.timeType == "DAY") {
        this.timeValue = dateFtt("yyyy-MM-dd", new Date());
      } else {
        this.timeValue = null;
      }
    },
    submit() {
      this.$emit("getDateData", {
        timeType: this.timeType,
        timeValue: this.timeValue,
        trigger: "change",
      });
    },
  },
  created() {
    this.handleDefaultTime();
    this.$emit("getDateData", {
      timeType: this.timeType,
      timeValue: this.timeValue,
      trigger: "created",
    });
  },
};
</script>

<style lang="scss" scoped>
.dateTypeChangeCom {
  @include setFlexStart;
  .el-select {
    width: 80px;
    margin-right: 10px;
  }
  .el-date-editor {
    width: 150px;
    margin-right: 10px;
  }
}
</style>
